export { default } from './svg/remove-fill.svg';
